// src/constants/seo.js
export const SITE_URL = 'https://mongsom.co.kr';
